// src/pages/AddProduct.js
import React, { useState } from "react";
import axios from "axios";
import "../styles/Forms.css";
import "../styles/Buttons.css";

const API_BASE_URL = "https://nzpdp-traceability-system-production-c63a.up.railway.app";

const AddProduct = () => {
  const [productData, setProductData] = useState({
    product_code: "",
    product_short_code: "",
    product_name: "",
    package_quantity: 0,
    net_weight: "",
    shelf_life: 0,
    brand: "",
    is_traceable: true,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData({ ...productData, [name]: value });
  };


  const handleSubmit = (e) => {
    e.preventDefault();

  
    if (!productData.brand.trim()) {
      alert("Please fill in the Brand field.");
      return;
    }

    axios
      .post(`${API_BASE_URL}/api/admin/add-product`, productData)
      .then((response) => {
    
        alert(response.data.message || "Product added successfully!");
      })
      .catch((error) => {
    
        if (
          error.response?.status === 400 &&
          error.response?.data?.error === "Product Code already exists."
        ) {
          alert("Error: This product code already exists. Please use a different code.");
        } else {
      
          alert(
            "Error adding product: " + (error.response?.data?.error || error.message)
          );
        }
      });
  };

  return (
    <div>
      <h3>Add New Product</h3>
      <form onSubmit={handleSubmit} className="admin-form">

        {/* Product Code */}
        <label>Product Code:</label>
        <input
          type="text"
          name="product_code"
          placeholder="Unique product code, e.g. F123P456"
          value={productData.product_code}
          onChange={handleChange}
          required
        />
        <p className="info-text">
          Please choose a unique product code (no duplicates allowed). Once created, it can’t be changed.
        </p>

        {/* Product Name */}
        <label>Product Name:</label>
        <input
          type="text"
          name="product_name"
          placeholder="e.g. IAMNZ Milk Powder 800G"
          value={productData.product_name}
          onChange={handleChange}
          required
        />
        <p className="info-text">
          The official name of the product shown on labels.
        </p>

        {/* Package Quantity */}
        <label>Package Quantity:</label>
        <input
          type="number"
          name="package_quantity"
          placeholder="e.g. 12"
          value={productData.package_quantity}
          onChange={handleChange}
          required
        />
        <p className="info-text">
          How many individual packs are in one carton (e.g. 12).
        </p>

        {/* Net Weight */}
        <label>Net Weight:</label>
        <input
          type="text"
          name="net_weight"
          placeholder="e.g. 500g"
          value={productData.net_weight}
          onChange={handleChange}
          required
        />
        <p className="info-text">
          The net weight per package (e.g. 500g).
        </p>

        {/* Shelf Life */}
        <label>Shelf Life (months):</label>
        <input
          type="number"
          name="shelf_life"
          placeholder="e.g. 12"
          value={productData.shelf_life}
          onChange={handleChange}
          required
        />
        <p className="info-text">
          The shelf life in months (e.g. 24).
        </p>

        {/* Brand */}
        <label>Brand:</label>
        <input
          type="text"
          name="brand"
          placeholder="e.g. IAMNZ"
          value={productData.brand}
          onChange={handleChange}
          required
        />
        <p className="info-text">
          Specify the brand name.
        </p>

        {/* Is Traceable? */}
        <label>Is Traceable?</label>
        <select
          name="is_traceable"
          value={productData.is_traceable}
          onChange={handleChange}
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
        <p className="info-text">
          If set to “No”, this product is considered “hided”.
        </p>

        <button type="submit">Add Product</button>
      </form>
    </div>
  );
};

export default AddProduct;
